import { render, staticRenderFns } from "./attachmentUpload1.vue?vue&type=template&id=1a270a74&scoped=true"
import script from "./attachmentUpload1.vue?vue&type=script&lang=js"
export * from "./attachmentUpload1.vue?vue&type=script&lang=js"
import style0 from "./attachmentUpload1.vue?vue&type=style&index=0&id=1a270a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a270a74",
  null
  
)

export default component.exports